import React from "react";
import { Link } from "react-router-dom";
import { Brand, BRAND } from "@/components/Brand";

const cols = [
  {
    title: "Product",
    links: [
      { to: "/generator", label: "QR Generator" },
      { to: "/reference/new", label: "Reference Pages" },
      { to: "/about", label: "About" },
      { to: "/faq", label: "FAQ" },
    ],
  },
  {
    title: "Legal",
    links: [
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Use" },
      { to: "/accessibility", label: "Accessibility" },
    ],
  },
  {
    title: "Support",
    links: [
      { to: "/support", label: "Contact & Support" },
      { to: "/faq", label: "Help / FAQ" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <Brand />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-500">{BRAND.tagline}</p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h3 className="text-sm font-semibold text-slate-900">{c.title}</h3>
              <ul className="mt-4 space-y-3">
                {c.links.map((l) => (
                  <li key={l.to + l.label}>
                    <Link to={l.to} className="text-sm text-slate-500 transition-colors hover:text-[#0D9488]">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-slate-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-slate-400" data-testid="footer-copyright">
            © {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-xs text-slate-400">
            <Link to="/privacy" className="transition-colors hover:text-[#0D9488]">Privacy Policy</Link>
            <span aria-hidden="true">·</span>
            <Link to="/terms" className="transition-colors hover:text-[#0D9488]">Terms of Use</Link>
            <span aria-hidden="true">·</span>
            <Link to="/support" className="transition-colors hover:text-[#0D9488]" data-testid="footer-support-link">Support</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
